import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = JSON.parse(localStorage.getItem("hoh_cart") || "[]");
      // Defensive: drop any legacy merch items lingering in localStorage.
      return Array.isArray(raw) ? raw.filter((i) => i.type !== "merch") : [];
    }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("hoh_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, format, price, extras = {}) => {
    if (product.type === "merch") return; // Merch is sold externally — never added to cart.
    const { quantity = 1 } = extras;
    const key = `${product.id}-${format}`;
    setItems((prev) => {
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => i.key === key ? { ...i, quantity: i.quantity + quantity } : i);
      }
      return [...prev, {
        key,
        product_id: product.id,
        format,
        price: Number(price),
        title: product.title,
        cover_image_url: product.cover_image_url,
        type: product.type,
        quantity,
      }];
    });
  };

  const updateQty = (key, qty) => setItems((prev) => prev.map((i) => i.key === key ? { ...i, quantity: Math.max(1, qty) } : i));
  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clearCart = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + Number(i.price || 0) * (i.quantity || 1), 0);
  const total = subtotal;

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clearCart, subtotal, total }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
